import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { adminApi } from '@/app/adminApi';
import { addressesApi } from '@/features/addresses/addressesApi';
import authSlice from '@/features/auth/authSlice';
import { employeesApi } from '@/features/employees';
import { equipmentGroupApi } from '@/features/equipmentGroup';
import { equipmentManufacturerApi } from '@/features/equipmentManufacturerApi';
import { equipmentTypeApi } from '@/features/equipmentTypeApi';
import { mainOrganizationApi } from '@/features/mainOrganization/mainOrganizationApi';
import { organizationsApi } from '@/features/organizations/organizationsApi';
import { rolesApi } from '@/features/roles/rolesApi';
import { serviceOrganizationsApi } from '@/features/serviceOrganizationsApi';
import { servicesApi } from '@/features/services/servicesApi';
import { sessionsApi } from '@/features/sessions/sessionsApi';
import { ssoIntegrationsApi } from '@/features/ssoIntegrations/ssoIntegrationsApi';
import { subdivisionsApi } from '@/features/subdivisions/subdivisionsApi';
import uiSlice from '@/features/ui/uiSlice';

const rootReducer = combineReducers({
  [adminApi.reducerPath]: adminApi.reducer,
  [uiSlice.name]: uiSlice.reducer,
  [addressesApi.reducerPath]: addressesApi.reducer,
  [authSlice.name]: authSlice.reducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  [equipmentGroupApi.reducerPath]: equipmentGroupApi.reducer,
  [equipmentManufacturerApi.reducerPath]: equipmentManufacturerApi.reducer,
  [equipmentTypeApi.reducerPath]: equipmentTypeApi.reducer,
  [mainOrganizationApi.reducerPath]: mainOrganizationApi.reducer,
  [organizationsApi.reducerPath]: organizationsApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [serviceOrganizationsApi.reducerPath]: serviceOrganizationsApi.reducer,
  [servicesApi.reducerPath]: servicesApi.reducer,
  [sessionsApi.reducerPath]: sessionsApi.reducer,
  [ssoIntegrationsApi.reducerPath]: ssoIntegrationsApi.reducer,
  [subdivisionsApi.reducerPath]: subdivisionsApi.reducer,
});

const middlewares = [
  adminApi.middleware,
  addressesApi.middleware,
  employeesApi.middleware,
  equipmentGroupApi.middleware,
  equipmentManufacturerApi.middleware,
  equipmentTypeApi.middleware,
  mainOrganizationApi.middleware,
  organizationsApi.middleware,
  rolesApi.middleware,
  serviceOrganizationsApi.middleware,
  servicesApi.middleware,
  sessionsApi.middleware,
  ssoIntegrationsApi.middleware,
  subdivisionsApi.middleware,
];

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
